import {
    hex2str
} from '@/assets/js/txActions'
import {
    fulltime
} from '@/assets/js/filters'
import {
    parseTransferNote
} from '@33cn/chain33-transaction-parser'

// Transfer
export let TransferNote = (str) => {
    str = str.substr(2)
    let buf = [];
    for (let i = 0; i < str.length; i += 2) {
        buf.push(parseInt(str.substring(i, i + 2), 16));
    }
    return readUTF(buf);
}

export let readUTF = function (arr) {

    if (typeof arr === 'string') {
        return arr;
    }
    let UTF = '',
        _arr = arr;
    for (let i = 0; i < _arr.length; i++) {
        let one = _arr[i].toString(2),
            v = one.match(/^1+?(?=0)/);
        if (v && one.length == 8) {
            let bytesLength = v[0].length;
            let store = _arr[i].toString(2).slice(7 - bytesLength);
            for (let st = 1; st < bytesLength; st++) {
                store += _arr[st + i].toString(2).slice(2)
            }
            UTF += String.fromCharCode(parseInt(store, 2));
            i += bytesLength - 1
        } else {
            UTF += String.fromCharCode(_arr[i])
        }
    }
    return UTF
}
//过滤年份
export let filterYear = (str) => {
    let arr = str.split('-')
    return arr[1] + '月' + arr[2] + '日'
}

//截断哈希
export let filterHash = (str) => {
    if (!str[0]) return ''
    if (str[1] < 500) return str[0].replace(/^(\w{8})(\w+)(\w{8})$/, '$1...$3')
    else return str[0].replace(/^(\w{18})(\w+)(\w{18})$/, '$1...$3')
}

//检验证书有效性
export let checkValid = (data = {}, adr = '1MS3u3F9K7FqaxU62C5egmdgiMzUhh7YaX') => {
    if (data.result.fromAddr !== adr) return '发证地址无效'
    else {
        let errmsg = null
        let dataInNote = null
        try {
            let noteString
            if (data.result.tx.payload.transfer && data.result.tx.payload.transfer.note) {
                // 5.0.2
                noteString = data.result.tx.payload.transfer.note
            } else if (data.result.tx.payload.Value.Transfer && data.result.tx.payload.Value.Transfer.note) {
                // 5.0.2.xxxx
                noteString = data.result.tx.payload.Value.Transfer.note
            }

            if (noteString) {
                // 6.0.2 以上 note字段为十六进制字符串
                if (noteString.substr(0, 2).toLowerCase() === '0x') {
                    noteString = hex2str(noteString)
                }
                dataInNote = JSON.parse(decodeURIComponent(atob(noteString)))
            }

        } catch (error) {
            /* eslint-disable-next-line */
            console.error(error)
            errmsg = '非证书哈希'
        }

        if (!dataInNote) {
            return '非证书哈希'
        }

        if (errmsg) {
            return errmsg
        }

        if (dataInNote.birthday && dataInNote.certificate_no && dataInNote.id && dataInNote.sex && dataInNote.stu_no && dataInNote.type && dataInNote.username) {
            return dataInNote
        } else {
            return '证书信息不完整'
        }
    }
}

// 校验宣言hash
export let checkRaw = (data = {}) => {
    let declare = 'user.p.ganme.declare'
    let agreement = 'user.p.ganme.agreement'
    let newdeclare = 'user.p.gmchain.declare'
    let newagreement = 'user.p.gmchain.agreement'
    // let write = 'user.p.ganme.write'
    if (data.tx.execer !== declare && data.tx.execer !== agreement && data.tx.execer !== newdeclare && data.tx.execer !== newagreement) return '非宣言 / 协议哈希'
    else if (data.tx.rawPayload) {
        return JSON.parse(TransferNote(data.tx.rawPayload))
    } else return '宣言 / 协议信息不完整'
}

// 校验手机hash
export let checkMobileHash = (data = {}, addr = '') => {
    if (data.fromAddr !== addr) return '非手机哈希'
    else if (data.tx.payload && data.tx.payload.transfer.note) {
        return JSON.parse(parseTransferNote(data.tx.payload.transfer.note))
    } else return '手机信息不完整'
}

export default {
    fulltime,
    filterHash,
    filterYear,
    checkValid,
    checkRaw
}